import React from 'react';
import T from 'prop-types';

import ChartCaptions from '../../_shared/components/ChartCaptions';
import MainSideLayout from '../../_shared/components/MainSideLayout';
import ChartLegend from '../../_render-chart/components/ChartLegend';

const CrossAppUsage = ({
  data,
  isMobileView,
}) => (
  <MainSideLayout
    title={<h2 className="main-side-layout__title h2">{data.header}</h2>}
    mainContent={(
      <div className="chart-image-legend-box">
        <img
          src={data[isMobileView ? 'chart_image_mobile_url' : 'chart_image_url']}
          alt={data.header}
          className="comparison-cross-app-usage__img"
        />
        <ChartLegend options={data.chart_legend} />
      </div>
    )}
    sideContent={(
      <ChartCaptions data={data.sections} />
    )}
    className="comparison-cross-app-usage"
  />
);

CrossAppUsage.propTypes = {
  data: T.shape({
    chart_image_url: T.string,
    header: T.string,
    sections: T.array,
    chart_legend: T.array,
  }).isRequired,
  isMobileView: T.bool.isRequired,
};

export default CrossAppUsage;
